import { addMinutes, format, isBefore } from 'date-fns';

interface IParams {
  startDate: string | null;
  endDate: string | null;
  remindDate: string | null;
  isDeactivated: boolean;
  dateFormat: string;
  facilityOffset: number;
}

export const getDates = ({
  startDate,
  endDate,
  remindDate,
  isDeactivated,
  dateFormat,
  facilityOffset,
}: IParams) => {
  try {
    const formattedStartDate = startDate
      ? format(addMinutes(startDate, facilityOffset * 60), dateFormat)
      : '-- --';

    const showScheduledDeactivation =
      !isDeactivated && startDate && isBefore(format(new Date(), dateFormat), startDate);

    const formattedEndDate = endDate ? format(addMinutes(endDate, facilityOffset * 60), dateFormat) : '-- --';

    const formattedRemindDate = remindDate
      ? format(addMinutes(remindDate, facilityOffset * 60), dateFormat)
      : '';

    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      remindDate: formattedRemindDate,
      showScheduledDeactivation,
    };
  } catch (error) {
    return {
      startDate: startDate ? startDate : '-- --',
      endDate: endDate ? endDate : '-- --',
      showScheduledDeactivation: false,
    };
  }
};
